// extracted by mini-css-extract-plugin
export default {"relatedLinksCollapse":"RelatedLinks_relatedLinksCollapse__+YDQ8"};